const limits = {
  manuscript: {
    words: {
      title: 50,
      abstract: 350,
    },
  },
  authors: {
    characters: {
      firstName: 40,
      initials: 40,
      lastName: 60,
      email: 128,
      institute: 512,
      city: 50,
    },
  },
  reviewers: {
    counts: {
      minRecommended: 2,
      maxRecommended: 5,
    },
    characters: {
      firstName: 40,
      lastName: 60,
      email: 128,
      reason: 100,
    },
  },
  themedCollection: {
    characters: {
      title: 4096,
    },
  },
  DAS: {
    characters: {
      statement: 4096,
    },
  },
  CCDC: {
    characters: {
      data: 4000,
    },
  },
} as const

export default limits
